// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentAutomations/update-event-status-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_TreatmentAutomations($event_id: uuid!, $status: String!) {
  automations_handle_status_toggle(event_id: $event_id, status: $status) {
    ok
    message
    event_id
  }
}

`